/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { CustomerCompanyDto } from './customer-company-dto';
import { CustomerContactDto } from './customer-contact-dto';
import { ClearanceCaseDto } from './clearance-case-dto';

//<custom-head>
import { orderBy } from 'lodash-es';
import { parseDate } from 'app/utils';
import { MessageDto } from '../models/message-dto';
//</custom-head>

export class CaseDto {
  public id: string = undefined;
  public ecomCaseNumber: string = undefined;
  public createdUtc: Date | string;
  public modifiedUtc: Date | string;
  public cancelledUtc: Date | string;
  public customer: CustomerCompanyDto;
  public contact: CustomerContactDto;
  public clearanceCase: ClearanceCaseDto;
  public messagesCount: number = undefined;
  public hasUnreadMessages: boolean;
  public invoiced: boolean;

  //<custom-body>
  public messageReceivedAfterFetch: Date;

  constructor(source: CaseDto) {
    Object.assign(this, source);

    if (source.customer) this.customer = new CustomerCompanyDto(source.customer);

    this.createdUtc   = parseDate(source.createdUtc);
    this.modifiedUtc  = parseDate(source.modifiedUtc);
    this.cancelledUtc = parseDate(source.cancelledUtc);
  }

  didReceiveMessage(unreadStatus: boolean): void {
    this.messageReceivedAfterFetch = new Date();
    this.messagesCount++;
    this.hasUnreadMessages = unreadStatus;
  }

  didReceiveMessageUpdate(updatedMessage: MessageDto, unreadStatus: boolean): void {
    this.hasUnreadMessages = unreadStatus;

    let message = this.clearanceCase.messages.find(m => m.id === updatedMessage.id);
      if (message != null)
        message.unread = unreadStatus;
  }
  //</custom-body>
}
